import React from 'react';
import {useIntl} from 'react-intl';
import {CurrencyInput, Table, Checkbox} from 'web-components';
import Util from '../../../forecast-app/shared/util/util';

const RateCardRoleTable = ({rateCardVersion, currency, handleRoleDefaultChange, handleRoleRateChange}) => {
	const intl = useIntl();

	return (
		<Table paddedCells>
			<Table.Header>
				<Table.HeaderColumn flex={1} visible usePadding width={Table.TABLE_COLUMN_WIDTH.LARGE}>
					<Table.HeaderColumn.Title>{intl.formatMessage({id: 'common.name'})}</Table.HeaderColumn.Title>
				</Table.HeaderColumn>
				<Table.HeaderColumn usePadding visible width={Table.TABLE_COLUMN_WIDTH.MEDIUM_SMALL}>
					<Table.HeaderColumn.Title>{intl.formatMessage({id: 'rate_card_modal.use_default_rate'})}</Table.HeaderColumn.Title>
				</Table.HeaderColumn>
				<Table.HeaderColumn usePadding visible width={Table.TABLE_COLUMN_WIDTH.MEDIUM} align={Table.TABLE_COLUMN_ALIGNMENT.RIGHT}>
					<Table.HeaderColumn.Title usePadding>{intl.formatMessage({id: 'common.rate'})}</Table.HeaderColumn.Title>
				</Table.HeaderColumn>
			</Table.Header>
			<Table.Rows
				data={{
					rows: rateCardVersion.roleRates,
				}}
			>
				{({rowData, tableColumnsProps}) => {
					return (
						<Table.Row {...tableColumnsProps}>
							<Table.Column>
								<Table.Column.Cell>{rowData.name}</Table.Column.Cell>
							</Table.Column>
							<Table.Column>
								<Checkbox checked={rowData.isUsingDefaultRate} onChange={e => handleRoleDefaultChange(rowData.roleId, e.target.checked)} />
							</Table.Column>
							<Table.Column>
								<CurrencyInput
									disabled={rowData.isUsingDefaultRate}
									value={rowData.rate !== null ? rowData.rate : rateCardVersion.defaultRate}
									currencySymbole={Util.GetCurrencySymbol(currency)}
									callback={rate => handleRoleRateChange(rowData.roleId, rate)}
									filterNonNumerics={true}
								/>
							</Table.Column>
						</Table.Row>
					);
				}}
			</Table.Rows>
		</Table>
	);
};

export default RateCardRoleTable;
